import DOMPurify from 'dompurify';

// Add hook to automatically add rel="noopener noreferrer" to links with target="_blank"
DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  // Set all elements owning target to target=_blank and add rel="noopener noreferrer"
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
  // Set non-HTML/MathML links to xlink:show=new
  if (!node.hasAttribute('target') &&
      (node.hasAttribute('xlink:href') || node.hasAttribute('href'))) {
    node.setAttribute('xlink:show', 'new');
  }
});

/**
 * Sanitize HTML to prevent XSS attacks
 * @param {string} html - The HTML string to sanitize
 * @param {object} config - DOMPurify configuration options
 * @returns {string} - Sanitized HTML string
 */
export function sanitizeHtml(html, config = {}) {
  if (!html || typeof html !== 'string') {
    return '';
  }

  // Default configuration - allows common safe HTML tags
  // NOTE: 'style' attribute is NOT allowed by default to reduce attack surface
  const defaultConfig = {
    ALLOWED_TAGS: [
      'a', 'b', 'br', 'code', 'div', 'em', 'i', 'li', 'ol', 'p', 'pre',
      'span', 'strong', 'ul', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'table', 'thead', 'tbody', 'tr', 'th', 'td', 'img', 'hr'
    ],
    ALLOWED_ATTR: [
      'class', 'id', 'href', 'target', 'title', 'alt', 'src',
      'width', 'height', 'colspan', 'rowspan', 'rel'
    ],
    ALLOW_DATA_ATTR: false,
    ...config
  };

  return DOMPurify.sanitize(html, defaultConfig);
}

/**
 * Vue plugin to add $sanitize method globally
 */
export default {
  install(Vue) {
    Vue.prototype.$sanitize = sanitizeHtml;

    // Add as a global filter for use in templates
    Vue.filter('sanitize', sanitizeHtml);
  }
};
